module.exports = __webpack_public_path__ + "media/images/writer/community/button-9013240af5d15a117b404aee045c90a6.png";